module.exports = __webpack_public_path__ + "img/Kd.55e66a75.png";